import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { DealerDto, DealerMenuItemDto } from '@core/dtos'
import { DealerHttp, GameHttp } from '@core/https'
import { AccountService } from '@core/services'
import { RoutePathEnum } from '@shared/enums'
import { MenuCardV2Component } from './menu-card-v2/menu-card-v2.component'
import { MenuCardV3Component } from './menu-card-v3/menu-card-v3.component'
import { ModalService } from '@shared/services'
import { ModalV2Component } from '@shared/components'
import { TablesInfoComponent } from './tables-info/tables-info.component'

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, MenuCardV2Component, ModalV2Component, MenuCardV3Component],
  providers: [DealerHttp],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.sass',
})
export class MenuComponent implements OnInit {
  private readonly userId = this._accountService.currentUserId

  dealers: DealerMenuItemDto[] = []

  constructor(
    private _gameHttp: GameHttp,
    private _accountService: AccountService,
    private _router: Router,
    private _modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
      this.dealers = i.dealerMenuItems

      if (i.currentDealerId !== undefined && i.currentDealerId !== null) {
        this._router.navigate([RoutePathEnum.CARD_GAME, i.currentDealerId])
      }
    })
  }

  trackByDealer(index: number, dealer: DealerDto) {
    return dealer.id
  }

  closeModal() {
    this._modalService.closeTableInfoModal()
  }
}
